import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { environment } from "@env/environment";
import { SharedService } from '@shared/services/shared.service';
import { PartnerService } from 'app/services/partner-service';
import { IPartnerAccessInfo } from 'app/models/partners/partners';
import { Router } from '@angular/router';

@Component({
  selector: 'app-partner-access',
  templateUrl: './partner-access.component.html',
  styleUrls: ['./partner-access.component.scss'],
  providers: [PartnerService],
})

export class PartnerAccessComponent implements OnInit {
  @Input() partnerId: number = 0;

  partnerAccess: IPartnerAccessInfo = null;
  loading: boolean = false;
  env = environment;
  accessGuid: string = '';
  validated: boolean = false;
  validatedDisclaimer: boolean = false;
  validatedPassKey: boolean = false;
  passKey: string = '';
  codeEntered: boolean = false;

  constructor(
    public dialog: MatDialog,
    public sharedService: SharedService,
    public partnerService: PartnerService,
    private router: Router,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.loading = true;
    this.accessGuid = this.router.url.split('/').pop();
    this.partnerService.getPartnerAccessInfo(this.accessGuid).subscribe(u => {
      this.partnerId = u.partnerId;
      this.partnerAccess = u;
      this.validatedDisclaimer = this.partnerAccess.requiresDisclaimerApproval ? false : true;
      this.validatedPassKey = this.partnerAccess.requiresPassKey ? false : true;
      this.validated = this.validatedDisclaimer && this.validatedPassKey;
      this.partnerService.accessGuid = this.accessGuid;
      this.loading = false;
    },
      error => {
        console.error('error: ' + error.statusText);
        this.toastr.error("Invalid Access Key");
        this.loading = false;
        this.router.navigateByUrl(`/sessions/403`, {
          skipLocationChange: true,
        });
      });
  }

  acceptDisclaimer() {
    this.validatedDisclaimer = true;
    this.validated = this.validatedDisclaimer && this.validatedPassKey;
  }

  checkPasskey() {
    this.codeEntered = this.passKey && this.passKey.length == 6;
    this.partnerService.passKey = this.passKey;
    this.cd.detectChanges();
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    // Allow: Backspace, Tab, End, Home, Arrow keys, Delete
    if (
      [8, 9, 13, 27, 46, 37, 38, 39, 40].indexOf(event.keyCode) !== -1 ||
      // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase()))
    ) {
      return;
    }
    // Prevent if not a number
    const num = Number(event.key);
    if (isNaN(num)) {
      event.preventDefault();
    }
  }

  sanitizePassKey() {
    this.passKey = (this.passKey || '').replace(/[^0-9]/g, '');
  }

  submitPassKey() {
    this.partnerService.passKey = this.passKey;
    this.partnerService.validatePartnerAccessInfo(this.partnerService.accessGuid, this.partnerService.passKey).subscribe(u => {
      if (u) {
        this.validatedPassKey = true;
        this.validated = this.validatedDisclaimer && this.validatedPassKey;
      } else {
        this.toastr.error("Invalid Pass Key");
      }
    },
      error => {
        console.error('error: ' + error.statusText);
        this.toastr.error("Invalid Pass Key");
      });
  }


  dialogClosed(result: any): void {
    if (result !== "Cancel") {
      this.load();
    }
  }

}

